import type { ContactDetails } from '@hemmafixa/shared';
import { DescriptionList } from '@hemmafixa/ui';
import { useI18n } from '@/i18n/context';

/** The other side's contact details, shown once the client has accepted a proposal (P5-02). */
export function ContactDetailsList({ contact }: { contact: ContactDetails }) {
  const { t } = useI18n();
  return (
    <div className="grid gap-2 rounded-lg border border-border p-4">
      <p className="text-sm font-semibold">{t.job.contactTitle}</p>
      <DescriptionList
        items={[
          { label: t.job.contactName, value: contact.name },
          {
            label: t.job.contactEmail,
            value: (
              <a href={`mailto:${contact.email}`} className="break-all underline underline-offset-4">
                {contact.email}
              </a>
            ),
          },
          ...(contact.phone
            ? [
                {
                  label: t.job.contactPhone,
                  value: (
                    <a href={`tel:${contact.phone}`} className="underline underline-offset-4">
                      {contact.phone}
                    </a>
                  ),
                },
              ]
            : []),
        ]}
      />
    </div>
  );
}
